import { render, staticRenderFns } from "./MyAddInput.vue?vue&type=template&id=24d0a750&scoped=true"
import script from "./MyAddInput.vue?vue&type=script&lang=js"
export * from "./MyAddInput.vue?vue&type=script&lang=js"
import style0 from "./MyAddInput.vue?vue&type=style&index=0&id=24d0a750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d0a750",
  null
  
)

export default component.exports